import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import { RoleRestricted, Roles } from "@app/user";
import MegaMenuHeader from "./MegaMenuHeader";
import MegaMenuLink from "./MegaMenuLink";
import { JSX } from "react";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
const ToolsMenu = (): JSX.Element => {
  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Tools" />
        <ul className="menu">
          <MegaMenuLink faIcon="search" menuItem={MenuItemEnum.LookupGeography} to="/tools/lookupstate" linkText="Lookup Geography" />
          <MegaMenuLink faIcon="map-marker" menuItem={MenuItemEnum.LookupAddress} to="/tools/lookupaddress" linkText="Lookup Address" />

          <RoleRestricted allowedRoles={[Roles.ACCURACY_EVIDENCE_VIEWER]}>
            <MegaMenuLink faIcon="search" menuItem={MenuItemEnum.AccuracyEvidence} to="/tools/accuracyevidence" linkText="Accuracy Evidence" />
          </RoleRestricted>
        </ul>
      </li>
    </ul>
  );
};

export default ToolsMenu;
